import { useEffect, useState } from "react";
import QRCode from "qrcode";

/** A QR code for a link, rendered as an image (nothing until it is ready). */
const QrCode = ({ value, size = 240, className = "qr-img", alt }) => {
  const [ready, setReady] = useState({ value: null, url: null });

  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(value, { margin: 1, width: size, color: { dark: "#23201b", light: "#ffffff" } })
      .then((url) => {
        if (!cancelled) setReady({ value, url });
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  if (ready.value !== value || !ready.url) return null;
  return <img className={className} src={ready.url} alt={alt ?? `QR code for ${value}`} />;
};

export default QrCode;
